<template>
    <article>
        <h2 class="mb-15">
            {{ $dictionary.get(props.headingLabel) }}
        </h2>
        <div class="relative"
             :class="{ 'border border-red-500': validationError }">
            <slot/>
            <SpinnerOverlay :show="showPlaceholder"
                            :delay="500"/>
        </div>
    </article>
</template>

<script setup lang="ts">
import SpinnerOverlay from '@/project/spinners/SpinnerOverlay.vue';

const props = defineProps({
    headingLabel: {
        type: String,
        required: true
    },
    showPlaceholder: {
        type: Boolean,
        default: false
    },
    validationError: {
        type: Boolean,
        default: false
    }
});
</script>
